import moment from "moment";

export default {
    methods: {
        getFormatedDate (event) {
            if (event.finishing_date) {
                if (event.starting_date) {
                    let startingDate = moment.utc(event.starting_date);
                    let finishingDate = moment.utc(event.finishing_date);
                    if (this.isSameDay(startingDate, finishingDate)) {
                        if (this.hasTime(startingDate) && this.hasTime(finishingDate)) {
                            return startingDate.format('HH:mm')
                                + " - " + finishingDate.format('HH:mm')
                                + ", " + startingDate.format('DD.MM.YYYY')
                        } else {
                            return startingDate.format('DD.MM.YYYY')
                        }
                    } else {
                        if (this.hasTime(startingDate) && this.hasTime(finishingDate)) {
                            return startingDate.format('HH:mm')
                                + " - " + finishingDate.format('HH:mm')
                                + ", " + startingDate.format('DD.MM.YYYY')
                                + " - " + finishingDate.format('DD.MM.YYYY')
                        } else {
                            return startingDate.format('DD.MM.YYYY')
                                + " - "
                                + finishingDate.format('DD.MM.YYYY')
                        }
                    }
                }
            } else {
                if (event.starting_date) {
                    let startingDate = moment.utc(event.starting_date);
                    if (this.hasTime(startingDate)) {
                        return startingDate.format('HH:mm, DD.MM.YYYY')
                    } else {
                        return startingDate.format('DD.MM.YYYY')
                    }
                }
            }
            return '';
        },
        hasTime(momentDate) {
            return !(momentDate.hour() === 0 && momentDate.minute() === 0);
        },
        isSameDay(startingDate, finishingDate) {
            return startingDate.format('DD.MM.YYYY') === finishingDate.format('DD.MM.YYYY')
        }
    }
}
